module.exports = __webpack_public_path__ + "assets/img/Spintel-Content-Marketing-w540.4a780a7d.jpg";